// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"styles_dataTableFormat__1amVz","formSpace":"styles_formSpace__2o-4b"};